import type { Theme } from "@mui/material/styles";
import type { AppSx } from "../types";

export interface DashboardCrossFilterBarComponentStyles {
  root: AppSx;
  label: AppSx;
}

export function buildDashboardCrossFilterBarComponentStyles(
  _theme: Theme
): DashboardCrossFilterBarComponentStyles {
  return {
    root: { mb: 1.5, px: { xs: 2, md: 3 } },
    label: { fontWeight: 600 },
  };
}
